'use client'
import { parseCountryName } from "@/libs/contentful/helper/newsParser";
import React, {createContext, Dispatch, SetStateAction, useState} from "react";

const buildObj = (arr: string[]) => {
    let obj = {};
    arr.forEach(item => {
        obj = {
            ...obj, [String(item)]: 0
        }
    });
    return obj
}

function createYearObject(startingYear:number) {
    const currentYear = new Date().getFullYear();
    const yearObject: {[key: string]: number} = {};

    for (let year = currentYear; year >= startingYear; year--) {
        const string = String(year);
        yearObject[string] = 0;
    }

    return yearObject;
}

interface Props {
    children?: React.ReactNode
    contentTags: {metadata: {tags: [], concepts: []}, sys: {id: string}, fields: {tagName: string}}[]
    contentTypes: {metadata: {tags: [], concepts: []}, sys: {id: string}, fields: {contentTypeName: string}}[]
    countries?: {metadata: {tags: [], concepts: []}, sys: {id: string}, fields: {countryName: string}}[]
    startingYear: number
}

export const numberOfContentTagsContext = createContext<{numberOfContentTags: {[key: string]: number}, setNumberOfContentTags: Dispatch<SetStateAction<{[key: string]: number}>>}>({
    numberOfContentTags: {},
    setNumberOfContentTags: (value) => value,
})

export const NumberOfContentTypesContext = createContext<{numberOfContentTypes: {[key: string]: number}, setNumberOfContentTypes: Dispatch<SetStateAction<{[key: string]: number}>>}>({
    numberOfContentTypes: {},
    setNumberOfContentTypes: (value) => value,
})

export const NumberOfYearsContext = createContext<{numberOfYears: {[key: string]: number}, setNumberOfYears: Dispatch<SetStateAction<{[key: string]: number}>>}>({
    numberOfYears: {},
    setNumberOfYears: (value) => value
})


export const NumberOfCountriesContext = createContext<{numberOfCountries: {[key: string]: number}, setNumberOfCountries: Dispatch<SetStateAction<{[key: string]: number}>>}>(
    {
        numberOfCountries: {},
        setNumberOfCountries: (value) => value
    }
)

export function NewsCounterProvider({ children, contentTags, contentTypes, countries = [], startingYear }:Props) {
    const contentTagObj = buildObj(contentTags.map(a => a.fields.tagName))
    const contentTypesObj = buildObj(contentTypes.map(a => a.fields.contentTypeName))
    const countriesObj = buildObj(
        countries.map(a => a.fields.countryName).filter(Boolean)
    )
    const yearsObj = createYearObject(startingYear)

    const [numberOfContentTags, setNumberOfContentTags] = useState(contentTagObj)
    const [numberOfContentTypes, setNumberOfContentTypes] = useState(contentTypesObj)
    const [numberOfCountries, setNumberOfCountries] = useState(countriesObj)
    const [numberOfYears, setNumberOfYears] = useState(yearsObj)

    return (
        <>
            <numberOfContentTagsContext.Provider value={{numberOfContentTags, setNumberOfContentTags}}>
                <NumberOfContentTypesContext.Provider value={{numberOfContentTypes, setNumberOfContentTypes}}>
                    <NumberOfCountriesContext.Provider value={{numberOfCountries, setNumberOfCountries}}>
                        <NumberOfYearsContext.Provider value={{numberOfYears, setNumberOfYears}}>
                            {children}
                        </NumberOfYearsContext.Provider>
                    </NumberOfCountriesContext.Provider>
                </NumberOfContentTypesContext.Provider>
            </numberOfContentTagsContext.Provider>
        </>
    )
}